import React from 'react';
import clsx from 'clsx';

import {Typography} from '@nur-portal/ui-kit';

import {DisLike} from './dislike';
import {getImageSrc} from './helpers';
import {Like} from './like';

import styles from './widget-nominant.module.css';

const WidgetNominant = ({
  name,
  positive,
  negative,
  currentPlace,
  photo,
  isLast = false,
  fullname
}) => {
  const imageSrc = getImageSrc(photo);

  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        <img src={imageSrc} alt={name} className={styles.image} />
        <span className={clsx(styles.place, {[styles.last]: isLast})}>{currentPlace}</span>
        <span className={styles.background} />
      </div>
      <div className={styles.infoWrapper}>
        <Typography variant='title-14' className={styles.name}>
          {fullname}
        </Typography>
        <div className={styles.votingWrapper}>
          <Like />
          <Typography variant='title-12' className={clsx(styles.voting, styles.positive)}>{positive}</Typography>
          <DisLike />
          <Typography variant='title-12' className={styles.voting}>{Math.abs(negative)}</Typography>
        </div>
      </div>
    </div>
  );
};

export {WidgetNominant};
